import type { ProductType } from '../../../../../types';
import useGetPresets from './useGetQuoteOptionPresets';
import type { GetPresetsResponse } from '../../../../../api/rater.api';
import type { FirmographicDataDto } from '../../../../../types/firmo/firmographic-data.dto';

export interface PxDetailsCoverages {
  name: string;
  limit: number;
  retroActivePeriod?: number;
  waitingPeriod: number;
  retroActiveDate?: string;
  uuid: string;
}

export interface UseMergePresetsAndCoveragesParams {
  effectiveDate: number | string;
  productType: ProductType;
  limit: number;
  deductible: number;
  agencyId: string;
  coverages: PxDetailsCoverages[];
  accountData: FirmographicDataDto;
}

const useMergePresetsAndCoverages = ({
  coverages,
  ...presetParams
}: UseMergePresetsAndCoveragesParams) => {
  const { data: presets, isLoading: isLoadingPresets } = useGetPresets(
    presetParams as any
  );

  let coveragesByGrouping = {} as GetPresetsResponse['coverageGroups'];
  if (coverages && presets && !isLoadingPresets) {
    coveragesByGrouping = presets.coverageGroups;
    const coverageMap = coverages.reduce(
      (acc, cov) => ({
        ...acc,
        [cov.name]: cov,
      }),
      {} as any
    );

    Object.keys(coveragesByGrouping).forEach((coverageGroup) => {
      coveragesByGrouping[coverageGroup].forEach((_coverage, index) => {
        const targetCoverage = coveragesByGrouping[coverageGroup][index];
        const { name } = targetCoverage.preset;

        if (name in coverageMap) {
          coveragesByGrouping[coverageGroup][index].preset = {
            ...coveragesByGrouping[coverageGroup][index].preset,
            ...coverageMap[name as keyof typeof coverageMap],
            ...targetCoverage,

            isSelected: true,
            isMandatory:
              coveragesByGrouping[coverageGroup][index].rules.isMandatory,
            fullName: targetCoverage.coverageFullName,
          };
        } else {
          coveragesByGrouping[coverageGroup][index].preset.isSelected = false;
          coveragesByGrouping[coverageGroup][index].preset.isMandatory =
            coveragesByGrouping[coverageGroup][index].rules.isMandatory;
          coveragesByGrouping[coverageGroup][index].preset.coverageFullName =
            targetCoverage.coverageFullName;
        }
      });
    });
  }

  return {
    coveragesByGrouping,
  };
};

export default useMergePresetsAndCoverages;
